import { useSubscriptionStore } from "@/store/subscription-store"
import { useCompanyStore } from "@/store/company-store"

export const CENSUS_AUDIT_LOGS_REFRESH_TIMEOUT__MILLISECONDS = 5000

function handleCompanyMembersChangedEvent() {
  useSubscriptionStore().loadActiveCompanySubscription()
}

function handleNoCensusChangeIndicatedEvent() {
  const companyStore = useCompanyStore()
  companyStore.loadWasEmployeeCensusUploadedInLast90Days()
  companyStore.loadLastEmployeeCensusUploadedDate()
}

function handleCensusUploadedEvent() {
  const companyStore = useCompanyStore()
  setTimeout(companyStore.loadWasEmployeeCensusUploadedInLast90Days, CENSUS_AUDIT_LOGS_REFRESH_TIMEOUT__MILLISECONDS)
  setTimeout(companyStore.loadLastEmployeeCensusUploadedDate, CENSUS_AUDIT_LOGS_REFRESH_TIMEOUT__MILLISECONDS)
}

export default {
  handleCompanyMembersChangedEvent,
  handleNoCensusChangeIndicatedEvent,
  handleCensusUploadedEvent
}
